// extracted by mini-css-extract-plugin
export default {"authenticatedLayout":"auth-wrapper_authenticatedLayout__2FC1s"};